export default __webpack_public_path__ + "static/media/css.7654ce00.png";